<div>
  {{'emptyCard.please' | translate}}
  <a data-toggle='modal' href="#" (click)="openModal()">{{linkText | async  }}</a>
  {{'emptyCard.profile' | translate}}
</div>